import { formatPhoneNumber } from 'app/formatPhoneNumber'

export default function PhoneNumber({
  number,
  className = ``,
}: {
  number?: string
  className?: string
}): React.ReactElement {
  return <div className={className}>{formatPhoneNumber(number)}</div>
}
